import FileSaver from "file-saver";
import { metricValueFormat } from "../../utils/metricValueFormat";

const formatPercentage = (rowData: any) => {
    const metricValue = rowData?.composite_score;
    if (metricValue === undefined || metricValue === null) {
        return '--';
    }
    return `${(metricValue * 100)?.toFixed(2)}%`;
};

const formatAttainment = (rowData: any) => {
    const totalAttained = rowData.total_metrics_attained || 0;
    const totalReported = rowData.total_metrics_reported || 0;

    const attainmentValue = `${totalAttained}/${totalReported}`;

    return attainmentValue;
};

const expAgent = (agents:any,metricColHeader:any) => {
    const expAge = [{}];
    for (let i = 0; i < agents.length; i++) {
        const agent = agents[i];
        let arr = [];
        arr = metricColHeader.map((x: any) => {
            let y = x;
            y = y.replaceAll(' - ', '_');
            let metricValue = agent.agentMetrics[0]?.metricsDetails[x]?.metric_value;
            const metricTypeName = agent.agentMetrics[0]?.metricsDetails[x]?.metric_type_name;
            if (metricValue === undefined || metricValue === null) {
                metricValue = '--';
            }
            else if (metricTypeName !== undefined) {
                metricValue = metricValueFormat(metricValue, metricTypeName);
            }
            return { [y]: metricValue };
        });

        expAge.push({
            'Oracle Id': `${agent.employee_number}`,
            'Employee Name': `${agent.employee_name}`,
            "Employee Role": agent.scorecard_role_id ===1 ? 'Agent': 'Team Lead',
            "Overall Rank": agent.overall_rank,
            "Composite Score": `${formatPercentage(agent)}`,
            "Attainment": `${formatAttainment(agent)}`,
        });
        arr.map((x: any) => {
            return Object.assign(expAge[i + 1], x);
        });
    }
    return expAge;
};

export const exportExcel = (agents: any,metricColHeader: any) => {
    import('xlsx').then((xlsx: any) => {
        const worksheet = xlsx.utils.json_to_sheet(expAgent(agents,metricColHeader));
        const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
        const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        saveAsExcelFile(excelBuffer, 'stackrank');
    });
};

const saveAsExcelFile = (buffer: any, fileName: any) => {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';
    const data = new Blob([buffer], {
        type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
};